import { Elements, PaymentElement, useElements, useStripe } from "@stripe/react-stripe-js";
import type { Stripe, StripeElements, StripeElementsOptions, StripePaymentElementLoadErrorEvent } from "@stripe/stripe-js";
import { useEffect } from "react";

type ReadyCallback = (stripe: Stripe, elements: StripeElements) => void;
type LoadErrorCallback = (event: StripePaymentElementLoadErrorEvent) => void;

function PaymentForm({
  onReady,
  onLoadError,
}: {
  onReady: ReadyCallback;
  onLoadError: LoadErrorCallback;
}) {
  const stripe = useStripe();
  const elements = useElements();

  useEffect(() => {
    if (stripe && elements) onReady(stripe, elements);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stripe, elements]);

  return <PaymentElement onLoadError={onLoadError} />;
}

export function StripePaymentElement({
  stripePromise,
  options,
  onReady,
  onLoadError,
}: {
  stripePromise: Promise<Stripe | null>;
  options: StripeElementsOptions;
  onReady: ReadyCallback;
  onLoadError: LoadErrorCallback;
}) {
  return (
    <Elements stripe={stripePromise} options={options}>
      <PaymentForm onReady={onReady} onLoadError={onLoadError} />
    </Elements>
  );
}
